<ng-container *ngIf="isLoaded">
  <button
    id="close-footbar"
    type="button"
    class="close"
    aria-label="Close"
    [mat-dialog-close]="false"
  >
    <span aria-hidden="true">×</span>
  </button>
  <h2 mat-dialog-title>{{ 'k003066' | translate }}</h2>
  <!--Token: Tu información ha sido validada -->
  <mat-dialog-content class="content">
    <div class="tech-operative-content2">
      <div class="justify" [innerHTML]="textParagraph1"></div>
      <div class="tablapartialdeposit card-gray">
        <div class="nombre1 blue-dark">{{ 'k002616' | translate }}</div>
        <!-- Token: Contribution account (IBAN) -->
        <div class="copy1 blue2">
          <span
            class="blue2 pointer"
            [cdkCopyToClipboard]="bankData.bankAccount"
            #tooltip0="matTooltip"
            matTooltipPosition="above"
            matTooltip="{{ 'k001886' | translate }}"
            (mouseenter)="$event.stopImmediatePropagation()"
            (mouseleave)="tooltip0.hide(2000)"
            (click)="tooltip0.toggle()"
          >
            <fa-icon [icon]="['fal', 'copy']"> </fa-icon>
            {{ bankData.bankAccount }}
          </span>
        </div>

        <div class="nombre2 blue-dark">
          {{ 'k002618' | translate }}
          <!-- Token: Beneficiary -->
        </div>
        <div class="copy2 blue2">
          <span
            class="pointer"
            [cdkCopyToClipboard]="bankData.beneficiaryName"
            #tooltip1="matTooltip"
            matTooltipPosition="above"
            matTooltip="{{ 'k001886' | translate }}"
            (mouseenter)="$event.stopImmediatePropagation()"
            (mouseleave)="tooltip1.hide(2000)"
            (click)="tooltip1.toggle()"
          >
            <fa-icon [icon]="['fal', 'copy']"></fa-icon>
            {{ bankData.beneficiaryName }}
          </span>
        </div>

        <div class="nombre3 blue-dark">{{ 'k002619' | translate }}</div>
        <!-- Token: Bic/Swift code -->
        <div class="copy3 blue2">
          <span
            class="pointer"
            [cdkCopyToClipboard]="bankData.swift"
            #tooltip2="matTooltip"
            matTooltipPosition="above"
            matTooltip="{{ 'k001886' | translate }}"
            (mouseenter)="$event.stopImmediatePropagation()"
            (mouseleave)="tooltip2.hide(2000)"
            (click)="tooltip2.toggle()"
          >
            <fa-icon [icon]="['fal', 'copy']"> </fa-icon>
            {{ bankData.swift }}
          </span>
        </div>

        <div class="nombre4 blue-dark">
          {{ 'k002620' | translate }}
        </div>
        <!-- Token: Bank -->
        <div class="copy4 blue2">
          <span
            [cdkCopyToClipboard]="bankData.bankName"
            #tooltip3="matTooltip"
            matTooltipPosition="above"
            matTooltip="{{ 'k001886' | translate }}"
            (mouseenter)="$event.stopImmediatePropagation()"
            (mouseleave)="tooltip3.hide(2000)"
            (click)="tooltip3.toggle()"
          >
            <fa-icon [icon]="['fal', 'copy']"> </fa-icon>
            {{ bankData.bankName }}
          </span>
        </div>

        <div class="nombre5 blue-dark">
          {{ 'k002621' | translate }}
        </div>
        <!-- Token: Transfer concept/message -->
        <div class="copy5 blue2">
          <span
            [cdkCopyToClipboard]="bankData.message"
            #tooltip4="matTooltip"
            matTooltipPosition="above"
            matTooltip="{{ 'k001886' | translate }}"
            (mouseenter)="$event.stopImmediatePropagation()"
            (mouseleave)="tooltip4.hide(2000)"
            (click)="tooltip4.toggle()"
          >
            <fa-icon [icon]="['fal', 'copy']"> </fa-icon>
            {{ bankData.message }}
          </span>
        </div>
      </div>
      <div class="justify mb-30" [innerHTML]="textParagraph2"></div>
    </div>
  </mat-dialog-content>
</ng-container>
